// @file Store for current user
import { getVuexStore } from '@@/bits/pinia'
import { defineStore } from 'pinia'
import type { User } from 'types'
import { computed } from 'vue'
import type { RootState } from 'vuexstore/surface/types'

export const useSurfaceCurrentUserStore = defineStore('surfaceCurrentUser', () => {
  const surfaceVuexStore = getVuexStore<RootState>()

  // Getters
  const currentUser = computed<User | undefined>(() => surfaceVuexStore?.getters.user)

  return {
    // Getters
    currentUser,
  }
})
